import { topicGroups } from "@/mocks/homeData";

const bucketColor: Record<string, { bar: string; dot: string }> = {
  who: { bar: "bg-primary-500", dot: "bg-primary-500" },
  id: { bar: "bg-accent-500", dot: "bg-accent-500" },
  bg: { bar: "bg-secondary-500", dot: "bg-secondary-500" },
  rel: { bar: "bg-primary-500", dot: "bg-primary-500" },
  acc: { bar: "bg-accent-500", dot: "bg-accent-500" },
  old: { bar: "bg-secondary-500", dot: "bg-secondary-500" },
};

export default function TopicWall() {
  return (
    <section id="topics" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-widest text-accent-700">追踪话题墙</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一个热曝该从哪里看起？按话题慢慢摸
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            同一个事件常横跨多个讨论向。下面按追踪向度把高频标签分好类，点一下就能顺着一条线看下去。
          </p>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {topicGroups.map((group) => {
            const color = bucketColor[group.id] ?? bucketColor.who;
            return (
              <article
                key={group.id}
                className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <div className="flex items-center gap-2">
                  <span className={`h-1.5 w-1.5 rounded-full ${color.dot}`} />
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{group.bucket}</h3>
                </div>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{group.blurb}</p>
                <div className="mt-4 flex flex-wrap gap-2 border-t border-secondary-100 pt-4">
                  {group.tags.map((tag) => (
                    <button
                      key={tag}
                      type="button"
                      className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900 transition-colors hover:bg-accent-100 hover:text-accent-900 whitespace-nowrap"
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 flex items-center gap-3 overflow-hidden rounded-lg bg-background-950 px-4 py-3">
          <span className="inline-flex shrink-0 items-center gap-1.5 text-xs font-medium text-accent-300">
            <i className="ri-double-quotes-l" />
            近期反复出现的高频句
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max gap-8 whitespace-nowrap text-xs text-background-100/80 animate-marquee">
              {Array.from({ length: 2 }).map((_, k) => (
                <div key={k} className="flex gap-8">
                  {["当事人是谁还不好说", "身份起底要讲证据", "背景深扒别只看一截", "关联人物对得上号吗", "旧料翻出先补语境", "社交账号内容需核实", "热度起来了更要冷静"].map(
                    (t) => (
                      <span key={t} className="inline-flex items-center gap-2">
                        <i className="ri-flashlight-line text-accent-400" />
                        {t}
                      </span>
                    ),
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}